import {Contacto} from './contacto';
import {Ubicacion} from '../ubicacion/ubicacion';
export class Sucursal {
    _id: string;
    descripcion: string;
    direccion: string;
    estado: boolean;
    provincia: string;
    localidad: string;
    empresa: string;
    contacto: Contacto[];
    central: boolean;
    ubicaciones: Ubicacion[];
    fechaCalibracion: any;

    alarmaActiva: boolean;
    alarmaSinActividadActiva: boolean;
    tiempoAlarmaSinActividadActiva: number;
    alarmaBateriaBajaActiva: boolean;
    historico_dias: number;
    color: String;
    colorAlarmaBateriaBajaActiva: String;
    husoHorario_id: any;
    nodoMantenimiento: boolean;
    alarmaSensorNullActivo: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/sucursal/sucursal.ts